module.exports = __webpack_public_path__ + "static/media/home-tile-1.174c7c2a.png";